module.exports = __webpack_public_path__ + "static/img/about_banner_01_zh.59d8882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_banner_01_zh.png
// module id = V+uE
// module chunks = 34